import CreditCardForm from "@/components/shared/creditCardForm/creditCardForm.vue";

export default {
  inject: ["$validator"],

  props: ["card"],

  components: {
    CreditCardForm,
  },

  data() {
    return {
      model: {
        firstName: "",
        lastName: "",
      },
      edit: false,
      request_started: false,
    };
  },

  methods: {
    validate,
    submit,
    close,
  },
};

async function validate() {
  this.$validator.validate().then(async (valid) => {
    if (!valid) {
      return;
    }

    this.submit();
  });
}

async function submit() {
  this.request_started = true;
  const newCardToken = await this.$refs.creditCardForm.submitCard();

  if (newCardToken) {
    this.$emit("save", {
      token: newCardToken,
      firstName: this.model.firstName,
      lastName: this.model.lastName,
    });
  } else {
    this.request_started = false;
  }
}

function close() {
  this.$emit("close");
}
